module.exports = __webpack_public_path__ + "static/img-flatware-115ee46339a19bc1055b443e3ad2d0ca.jpg";